import React from "react";
import { Car, ScanLine, Clock, Activity } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useI18n } from "@/i18n";

const ICONS = [<Car size={18} />, <ScanLine size={18} />, <Clock size={18} />, <Activity size={18} />];

export function Problem() {
  const { t } = useI18n();
  const p = t.problem;
  return (
    <section id="problem" className="bg-background py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <p className="overline text-accent">{p.overline}</p>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl tracking-tight leading-[1.02]">{p.title}</h2>
          <ul className="mt-10 space-y-5">
            {p.items.map((it, i) => (
              <li key={i} className="flex items-center gap-4" data-testid={`problem-item-${i}`}>
                <span className="grid place-items-center h-10 w-10 rounded-full border border-border text-accent">{ICONS[i]}</span>
                <span className="text-foreground/90 text-lg">{it}</span>
              </li>
            ))}
          </ul>
          <p className="mt-10 font-serif italic text-2xl md:text-3xl text-gold leading-snug max-w-lg" data-testid="problem-note">{p.note}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="relative overflow-hidden border border-border">
            <img
              src="https://images.pexels.com/photos/14805998/pexels-photo-14805998.jpeg"
              alt="Business traveler waiting"
              className="w-full h-[520px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-midnight/50 to-transparent" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
